import TcnAuGroupInput from "./TcnAuGroupAvatar.vue"

export default TcnAuGroupInput